/* Fuerza Pura - pagina de producto: galeria, variantes, cantidad, agregar al carrito y barra fija. */
(function () {
  'use strict';

  function money(cents, cur) {
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: cur, minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function init(root) {
    if (root.getAttribute('data-fp-ready')) return;
    root.setAttribute('data-fp-ready', '1');

    var form = root.querySelector('.fp-pf');
    var dataEl = root.querySelector('[data-fp-variants]');
    if (!form || !dataEl) return;

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var cur = root.getAttribute('data-currency') || 'MXN';
    var productId = root.getAttribute('data-product-id') || '';

    var idInput = form.querySelector('input[name=id]');
    var qty = form.querySelector('input[name=quantity]');
    var addBtn = form.querySelector('[data-fp-add-main]');
    var addText = form.querySelector('[data-fp-add-text]');
    var nowEl = root.querySelector('[data-fp-now]');
    var wasEl = root.querySelector('[data-fp-was]');
    var saveEl = root.querySelector('[data-fp-save]');
    var tagEl = root.querySelector('[data-fp-tag]');
    var stockEl = root.querySelector('[data-fp-stock]');
    var skuEl = root.querySelector('[data-fp-sku]');
    var sticky = root.querySelector('[data-fp-sticky]');
    var stickyBtn = root.querySelector('[data-fp-sticky-add]');
    var stickyPrice = root.querySelector('[data-fp-sticky-price]');
    var track = root.querySelector('[data-fp-track]');
    var thumbs = root.querySelectorAll('[data-fp-thumb]');
    var count = root.querySelector('[data-fp-count]');

    /* ----- galeria ----- */
    function slideCount() { return track ? track.querySelectorAll('.fp-pg__slide').length : 0; }
    function goTo(i) {
      if (!track) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    var ticking = false;
    function onScroll() {
      if (ticking || !track) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (count) count.textContent = (idx + 1) + ' / ' + slideCount();
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
      });
    }
    if (track) track.addEventListener('scroll', onScroll, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });

    /* ----- variantes ----- */
    function selectedVariant() {
      var groups = form.querySelectorAll('.fp-opt');
      if (!groups.length) return variants[0];
      var vals = [];
      groups.forEach(function (g) {
        var c = g.querySelector('input:checked');
        vals.push(c ? c.value : null);
        var lab = g.querySelector('[data-fp-optval]');
        if (lab && c) lab.textContent = c.value;
      });
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      })[0];
    }

    function update(v) {
      if (!v) {
        addBtn.disabled = true;
        addText.textContent = 'No disponible';
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      nowEl.textContent = money(v.price, cur);
      nowEl.classList.toggle('is-sale', !!sale);
      if (wasEl) { wasEl.hidden = !sale; if (sale) wasEl.textContent = money(v.compare_at_price, cur); }
      if (saveEl) { saveEl.hidden = !sale; if (sale) saveEl.textContent = 'Ahorras ' + money(v.compare_at_price - v.price, cur); }
      if (tagEl) { tagEl.hidden = !sale; if (sale) tagEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      addBtn.disabled = !v.available;
      addText.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
      if (stockEl) stockEl.textContent = v.available ? 'Disponible' : 'Agotado';
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      if (stickyPrice) stickyPrice.textContent = money(v.price, cur);
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Agregar' : 'Agotado'; }
      if (window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(null, '', u.toString());
        } catch (e) {}
      }
      var mid = v.featured_media && v.featured_media.id;
      if (mid && track) {
        var list = track.querySelectorAll('.fp-pg__slide');
        for (var i = 0; i < list.length; i++) {
          if (String(list[i].getAttribute('data-media-id')) === String(mid)) { goTo(i); break; }
        }
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.fp-opt input')) update(selectedVariant());
    });

    /* ----- cantidad ----- */
    var minus = form.querySelector('[data-fp-minus]');
    var plus = form.querySelector('[data-fp-plus]');
    if (qty && minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (qty && plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

    /* ----- agregar al carrito ----- */
    function doAdd(btn, textEl, idle) {
      if (!window.FPCart) { form.submit(); return; }
      if (btn.getAttribute('data-busy') || btn.disabled) return;
      btn.setAttribute('data-busy', '1');
      btn.classList.add('is-loading');
      if (textEl) textEl.textContent = 'Agregando...';
      var q = Math.max(1, parseInt(qty ? qty.value : '1', 10) || 1);
      window.FPCart.add(Number(idInput.value), q, productId).then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        if (textEl) textEl.textContent = 'Agregado';
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.removeAttribute('data-busy');
          if (textEl) textEl.textContent = idle;
        }, 1800);
      }).catch(function (err) {
        if (err && err.added) { window.location.href = '/cart'; } else { form.submit(); }
      });
    }
    form.addEventListener('submit', function (e) {
      if (!window.FPCart || !addBtn || addBtn.disabled) return;
      e.preventDefault();
      doAdd(addBtn, addText, 'Agregar al carrito');
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { doAdd(stickyBtn, stickyBtn, 'Agregar'); });

    /* ----- barra fija ----- */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      }, { threshold: 0 });
      so.observe(addBtn);
    }

    /* ----- descripcion: ver mas / ver menos ----- */
    var prose = root.querySelector('[data-fp-prose]');
    var more = root.querySelector('[data-fp-more]');
    if (prose && more && prose.scrollHeight > 620) {
      prose.classList.add('is-collapsible');
      more.hidden = false;
      more.addEventListener('click', function () {
        var open = prose.classList.toggle('is-open');
        more.textContent = open ? 'Ver menos' : 'Ver más';
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-fp-product]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
